export default function () {
  localStorage.setItem("username", "");
  localStorage.setItem("authorization", "");
  sessionStorage.setItem("navName", "");
  sessionStorage.setItem("navIcon", "");
  sessionStorage.setItem('is_menuData',"")
  sessionStorage.setItem("avatar", "");
  sessionStorage.setItem("authorization", "");
}



// WEBPACK FOOTER //
// ./src/utils/clearInfo.js